export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-50 to-background-200/30 rounded-2xl p-8 md:p-12 border border-background-200/60 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-3">随时随地 · 高清观影</h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">
              萝卜影视全面适配移动端浏览器，无需下载App即可畅享电影在线观看高清体验。在手机、平板上打开网站，自动适配屏幕尺寸，
              流畅播放高清影片，让好电影随时随地陪伴你。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="w-32 h-10 bg-background-200/50 rounded-lg flex items-center justify-center text-xs text-foreground-500 whitespace-nowrap">
                移动端入口
              </div>
              <span className="text-xs text-foreground-600">直接在浏览器打开即可</span>
            </div>
          </div>
          <div className="flex-shrink-0 w-40 h-64 bg-background-200/40 rounded-2xl border border-background-300/40 flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20mockup%20displaying%20cinematic%20movie%20streaming%20interface%20with%20dark%20theme%2C%20film%20poster%20thumbnails%2C%20warm%20golden%20accents%2C%20minimalist%20UI%20design%2C%20floating%20on%20dark%20background%2C%20premium%20product%20photography%2C%20soft%20dramatic%20lighting&width=400&height=700&seq=app-mobile&orientation=portrait"
              alt="萝卜影视移动端观影"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}